<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-otp"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
                <div id="otp_base" class="modal-base"
                    :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                    <div class="modal-base-header">
                        <div id="otp_header" class="theme-txt">{{lbl.otp.headline}}</div>
                        <!-- <div id="otp_close"
                            @click="clickClose">
                            <img class="img-fluid" src="../../../assets/image/Register/close_farmer.png" />
                        </div> -->
                    </div>
                    <div class="modal-base-body">
                        <div class="otp-txt">{{lbl.otp.line1}}</div>
                        <div class="otp-contact">{{displayContactNumber}}</div>

                        <div id="otp_refcode" class="otp-txt">
                            {{lbl.otp.ref_code}}
                            <span id="otp_refcode_txt">{{refcode}}</span>
                        </div>

                        <div id="otp_layout">
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(0)}">
                                    {{otpLbl(0)}}
                                </label>
                            </div>
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(1)}">
                                    {{otpLbl(1)}}
                                </label>
                            </div>
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(2)}">
                                    {{otpLbl(2)}}
                                </label>
                            </div>
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(3)}">
                                    {{otpLbl(3)}}
                                </label>
                            </div>
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(4)}">
                                    {{otpLbl(4)}}
                                </label>
                            </div>
                            <div class="otp-block">
                                <label class="otp-lbl"
                                    for="otp_input_box"
                                    :class="{'otp-lbl-fill': otpLbl(5)}">
                                    {{otpLbl(5)}}
                                </label>
                            </div>
                            <div id="otp_input">
                                <input id="otp_input_box"
                                    type="tel"
                                    v-model="otp"
                                    :maxlength="6"
                                    @input="onChange()" />
                            </div>
                        </div>
                        <div id="otp_error" v-if="isShowErr">
                            <div v-html="errMsg"></div>
                            <div class="mt-3">{{ lbl.otp.err_code }}{{ errorCode }}</div>
                        </div>
                        <div id="otp_time_left" :class="[isShowErr ? 'pb-3' : 'py-3']"
                            v-if="!isShowResendOTP">
                            <div class="txt-time">
                                {{lbl.otp.expire_in}}
                            </div>
                            <div class="timer">
                                {{timer.displayTime}}
                            </div>
                        </div>
                        <div id="otp_resend" :class="[isShowErr ? 'pb-3' : 'py-3']"
                            v-if="isShowResendOTP"
                            @click="clickResentOTP">
                            {{lbl.otp.resend_otp}}
                        </div>
                    </div>
                    <div class="modal-base-footer">
                        <div id="send_otp_btn">
                            <div class="otp-btn-close">
                                <div class="btn-tranparent-wrapper">
                                    <div class="btn-txt"
                                        @click="clickClose">
                                            {{lbl.default.close}}
                                        </div>
                                </div>
                            </div>
                            <div class="otp-btn-next">
                                <div class="btn-wrapper"
                                    :class="{'btn-disable': !isEnableSubmit || isShowResendOTP}">
                                    <div class="btn-txt"
                                        @click="clickSubmitOTP()">
                                        {{lbl.otp.confirm_btn}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue';
import Locale from "@/helper/locale/locale.js";
//Helper
//import Util from "@/helper/Utility.js";
import Timer from '@/helper/TimerHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//Service
// import { AuthRequestOTPModel } from '@/core/Account/model/AuthConfigModel.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
//error
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";

export default {
    name: 'OTPModal',
    mixins: [ErrorApiMixin],
    props: {
        controller: Object,
        modalId: String,
        theme: String
    },
    computed: {
        displayContactNumber: function () {
            if (!this.contactNumber) return;

            var n1, n2, n3;
            var formatted = this.contactNumber;
            n1 = formatted.substr(0, 3);
            n2 = formatted.substr(3, 3);
            n3 = 'XXXX';
            return n1 + this.delimeter + n2 + this.delimeter + n3;
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            tag: '',

            contactNumber: '',
            delimeter: '',
            requestChannel: '',
            isShowResendOTP: false,
            isEnableSubmit: false,
            otp: '',
            refcode: '',
            otpLifeTime: 0,
            displayTime: '',
            isExpireTime: false,

            isShowErr: false,
            errMsg: '',
            errorCode: '',

            timer: new Timer(),
            busModal: null,

            trackingService: new TrackingService(this),
        };
    },
    // beforeCreate: function () {
    // },
    created: function () {
        this.busModal = this.controller.busModal;

        var trackingEventCategory = 'register'
        var eventName = 'view_register_otp'
        this.trackingService.event(trackingEventCategory, eventName, null, null)

        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.controller.alertModal);
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('startOtp', this.startOtp);
        this.busModal.$on('showError', this.showError);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        show: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.resetOTP();
            this.$bvModal.hide(this.modalId);
        },
        //#region otp
        startOtp: async function(config) {
            this.clearError();
            this.otp = '';
            this.tag = config.tag;
            this.contactNumber = config.contactNumber;
            this.delimeter = config.delimeter;
            this.requestChannel = config.requestChannel;

            var data = await this.apiRequestOtp();
            
            if (data) {
                this.otpLifeTime = data.expireinseconds
                this.timer.stopTimer();
                this.timer.resetTimer();
                this.timer.initialTimer(data.expireinseconds);
                this.timer.runTimer(() => {
                    this.setTimeout();
                });
                this.show();
            }
        },
        apiRequestOtp: async function() {
            return new Promise((resolve, reject) => {
                BzbsAuth.apiRequestOTP(this.contactNumber, this.requestChannel)
                    .then((res) => {
                        this.refcode = res.data.refcode;
                        resolve(res.data);
                    })
                    .catch((err) => {
                        console.log(err.response && err.response.data && err.response.data.error.code);
                        if (err.response && err.response.data) {
                            this.controller.sendCallbackError(err.response.data.error);
                        }
                        // var errorHandler = new ErrorHandler();
                        // errorHandler.onError2128 = () => {
                        //     this.controller.alertModal
                        //         .clearText()
                        //         .setMsg("เบอร์โทรซ้ำ")
                        //         .show();
                        //     this.controller.alertModal.onClickOk(() => {
                        //         this.controller.sendCallbackError(err);
                        //     });
                        // };
                        // this.errorApi(err, errorHandler);
                        reject(false);
                    });
            });
        },
        setTimeout: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.isExpireTime = true;
            this.isShowResendOTP = true;
        },
        //Event
        clickSubmitOTP: function () {
            console.log('clickSubmitOTP', this.otp.length);
            if (this.otp.length == 6) {
                var callbackData = {
                        tag: this.tag,
                        contact_number: this.contactNumber,
                        refcode: this.refcode,
                        otp: this.otp
                };
                console.log(callbackData);
                
                this.controller.sendCallbackSubmitOTP(callbackData);
                // this.hide();
            }
        },
        clickResentOTP: async function () {
            this.isExpireTime = false;
            this.refcode = '';
            this.otp = '';

            await this.apiRequestOtp();
            this.startTimeOtp();
        },
        startTimeOtp: function() {
            this.isExpireTime = false;
            this.isShowResendOTP = false;
            this.timer.runTimer((displayTime) => {
                this.displayTime = displayTime;
            }, () => {
                this.setTimeout();
            })
        },
        clickClose: function () {
            this.hide()
            this.resetOTP();
            this.controller.sendCallbackClose({ tag: this.tag });
        },
        //End Event
        onChange: function () {
            if (!this.otp) return;
            this.clearError();

            var otp = this.otp;
            otp = otp.replace(Vue.RegExp.emoji, '');
            otp = otp.replace(Vue.RegExp.notNumber, '');

            this.otp = otp;
            this.isEnableSubmit = (this.otp.length == 6);
        },
        resetOTP: function () {
            this.isShowResendOTP = false;
            this.otp = '';
            this.timer.stopTimer();
        },
        //Method
        // expired: function () {
        //     this.isShowResendOTP = true;
        // },
        
        showError: function (error) {
            console.log('showError', error);
            this.timer.stopTimer();
            this.isShowErr = error.isShow;
            this.errMsg = error.err.message;
            this.errorCode = error.err.code;
            this.timer.runTimer(() => {
                this.setTimeout();
            });
            this.$bvModal.show(this.modalId);
        },
        clearError: function () {
            this.isShowErr = false;
            this.errMsg = '';
        },
        //End Method
        //Utility
        otpLbl: function (index) {
            if (!this.otp) return;

            return this.otp.length >= index
                        ? this.otp[index]
                        : '';
        }
        //End Utility
    }
};
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    @import "@/style/base/base.scss";
    .modal-otp {
        @extend %modal-base;

        .modal-dialog {
            // max-width: 450px;
            margin: auto;

            .modal-content {
                .modal-body {
                    padding: 16px 16px 24px;
                }
            }
        }

        .modal-base-header {
            position: relative;
            width: 100%;

            #otp_header {
                width: 100%;
                //font
                font-size: 1.75rem;
                font-family: $semi_bold;
                text-align: center;
                line-height: 1;
            }

            #otp_close {
                position: absolute;
                top: -5px;
                right: -3px;
                width: 18px;
                height: 18px;
            }
        }

        .modal-base-body {
            padding: 18px 0 0;

            .otp-txt {
                width: 100%;
                font-size: 1.5rem;
                text-align: center;
                line-height: normal;
                color: $a-gray-575757;
                padding-bottom: 8px;
            }
            .otp-contact {
                width: 100%;
                font-size: 1.75rem;
                text-align: center;
                line-height: normal;
                color: $a-gray-575757;
                font-family: $semi_bold;
            }

            #otp_refcode {
                margin-top: 16px;

                #otp_refcode_txt {
                    color: $green-00987F;
                    line-height: 1;
                }
            }

            #otp_layout {
                @extend %display-flex;
                position: relative;
                width: 100%;

                .otp-block {
                    width: calc(100% / 6);
                    flex : 0 0 calc(100% / 6);
                    padding: 0 5px;
                    height: 50px;

                    .otp-lbl {
                        width: 100%;
                        padding: 6px 0;
                        height: 50px;
                        border: 1px solid $a-gray-C4C4C4;
                        border-radius: 8px;
                        //font
                        font-size: 1.7rem;
                        line-height: 1.5;
                        text-align: center;
                        font-family: $bold;
                        cursor: pointer;

                        &.otp-lbl-fill {
                            border: 1px solid $green-00987F;
                        }
                    }
                }

                #otp_input {
                    position: absolute;
                    top: -10000%;
                    left: 0;
                    right: 0;

                    input:focus {
                        outline: none;
                    }
                }
            }

            %otp-time-resend {
                width: 100%;
                //font
                font-size: 1rem;
                text-align: center;
            }

            #otp_time_left {
                @extend %otp-time-resend;
                @extend %display-flex;
                width: 100%;
                flex : 0 0 calc(100% / 2);
                align-items: center;
                justify-content: center;
                gap: 10px;
                text-align: center;
                .txt-time {
                    font-size: 1.5rem;
                    color: $a-gray-575757
                }
                .timer {
                    font-size: 1.75rem;
                    color: $green-00987F;
                    font-family: $semi_bold;
                }
            }

            #otp_resend {
                @extend %otp-time-resend;
                color: $green-00987F;
                font-size: 1.25rem;
                font-family: $semi_bold;
                padding: 0 0 16px;
                cursor: pointer;
            }
        }

        #send_otp_btn {
            @extend %display-flex;
            width: 100%;
            flex : 0 0 calc(100% / 2);
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            height: 45px;

            .otp-btn-close {
                width: 35%;
                .btn-tranparent-wrapper {
                    // @include btn-tranparent-wrapper($gray-808080, $gray-808080);
                    height: 45px;
                    .btn-txt {
                        width: 100%;
                        flex: 0 0 100%;
                        margin: auto;
                        padding: 0 15px;
                        //font
                        font-size: 1.5rem;
                        text-align: center;
                    }
                }
            }
            .otp-btn-next {
                width: 60%;
                .btn-wrapper {
                    // border: 1px solid $green-00987F;
                    height: 45px;
                }
            }
        }

        #otp_error {
            width: 100%;
            margin: 20px 0 16px;
            //font
            color: $a-red-C03744;
            font-size: 1.25rem;
            text-align: center;
            line-height: 1;
        }
    }


</style>
